import { mergeDefaultProps } from "@kobalte/utils";
import { createEffect, onCleanup } from "solid-js";
import { useDomCollectionContext } from "./dom-collection-context";
export function createDomCollectionItem(props) {
    const context = useDomCollectionContext();
    const mergedProps = mergeDefaultProps({ shouldRegisterItem: true }, props);
    createEffect(() => {
        if (!mergedProps.shouldRegisterItem) {
            return;
        }
        const unregister = context.registerItem(mergedProps.getItem());
        onCleanup(unregister);
    });
}
